module.exports = __webpack_public_path__ + "static/media/onboarding-user-step1.1979eabb.svg";